import LogoImg from '../assets/img/logo-black.png'

export default function Header({collection}) {
    return (
      <div className="fixed top-5 left-4 md:top-10 md:left-10 flex flex-row z-[2]">
        {/* <img onClick={()=> window.open("../../","_self")} src={LogoImg} alt='Montauksofa logo' className='cursor-pointer'/> */}
        <img src={LogoImg} alt='Montauksofa logo' className=''/>
        <p className='px-14 md:px-20 md:py-10 text-black text-[32px] font-normal leading-normal font-NeueMTL'>{collection.name.toLowerCase()}</p>
      </div>
    );
  }
  